import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=374459b1&"
import script from "./Editor.vue?vue&type=script&lang=js&"
export * from "./Editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/agent_ai/agent-ai-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('374459b1')) {
      api.createRecord('374459b1', component.options)
    } else {
      api.reload('374459b1', component.options)
    }
    module.hot.accept("./Editor.vue?vue&type=template&id=374459b1&", function () {
      api.rerender('374459b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/Editor.vue"
export default component.exports